export default {
	TABLE_TITLE: 'Market payroll periods',
	MARKET_PAYROLL_PERIOD_ADDED: 'Market payroll period added',
	MARKET_PAYROLL_PERIOD_EDITED: 'Market payroll period edited',
	MARKET_PAYROLL_PERIOD_DELETED: 'Market payroll period deleted',
	MODAL_TIP: 'Max salary period is 3 months.',
};
